import { action } from 'typesafe-actions';

import { AccessLog } from 'models/accessLog';

import { Reset } from './generic';

export const LOAD_ACCESS_LOG = 'LOAD_ACCESS_LOG';

export const SUCCESS_ACCESS_LOG = 'SUCCESS_ACCESS_LOG';

interface Access {
  type: typeof SUCCESS_ACCESS_LOG;
  data: AccessLog;
}

export type AccessLogAction = Access | Reset;

export const accessRequest = () => action(LOAD_ACCESS_LOG);

export const doLoadHasAccess = (data: AccessLog): AccessLogAction => ({
  type: SUCCESS_ACCESS_LOG,
  data,
});
